import React from 'react';
import Product from './Product/';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';

const ProductWithClickTracking = WithClickTracking(Product);

const ProductList = ({ products, onResultClick, addToCart, translationUtility }) =>
    <div className="product-list">
        <div className="row">
            {products.map((product, i) => {
                return (
                    <ProductWithClickTracking 
                        key={i}
                        onResultClick={onResultClick}
                        {...product}
                        addToCart={addToCart}
                        translationUtility={translationUtility}
                    />
                );
            })}
        </div>
    </div>;

ProductList.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        IsRestricted: PropTypes.bool
    })),
    addToCart: PropTypes.func,
};

export default ProductList;


// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/ProductList.jsx